import { env } from '@/config/env'

/**
 * `GET /cases/:id/documents/:id/download`'s `url` is relative in local dev (the filesystem
 * storage adapter's own `/api/v1/_storage/local?key=...` route) but a fully-qualified Azure SAS
 * URL in production — opening a relative one as-is would resolve against the frontend's own
 * origin instead of the backend and 404. Prepend the API origin only when the URL isn't already
 * absolute.
 */
export function normalizeDownloadUrl(url: string): string {
  return /^https?:\/\//i.test(url) ? url : `${env.NEXT_PUBLIC_API_URL}${url}`
}
